export default __webpack_public_path__ + "static/media/Pueri.bbd399d6.jpg";